import React, { lazy, Suspense } from 'react';
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import ErrorBoundary from './ErrorBoundary';
import Loader from '@iso/components/utility/loader';
import Layout from './components/Layout/';

const Dashboard = lazy(() => import('./containers/Dashboard/Dashboard'));
const Page = lazy(() => import('./containers/BlankPage'));
const Networking = lazy(() => import('./containers/PagesPublic/Networking/Networking'));
const BeachBlue = lazy(() => import('./containers/PagesPublic/BlueBeach/BlueBeach'));

const publicRoutes = [
  {
    path: '',
    exact: true,
    component: withLayout(Networking)
  }
];
function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = useSelector((state) => state.Auth.idToken);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Switch>
          <Route
              exact
              path={'networking'}
              component={withLayout(Networking)}
            />  
            <Route
              exact
              path={''}
              component={withLayout(BeachBlue)}
            />  
            {/* {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))} */}
            <PrivateRoute path="/dashboard">
              <Dashboard />
            </PrivateRoute>
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}

function withLayout (WrappedComponent) {
  return class extends React.Component {  
    render() {
      return <Layout>
        <WrappedComponent></WrappedComponent>
      </Layout>
    }
  };
}

// import React, {lazy, Suspense}  from 'react';
// import { Route, Redirect, Router,Switch, Link } from 'react-router-dom';
// import { ConnectedRouter } from 'connected-react-router';
// import {useSelector, useDispatch} from 'react-redux';
// // import authAction from './redux/auth/actions';
// import Loader from './components/utility/loader';
// import Layout from "./components/Layout/";

//   const Page = lazy(() => import('./containers/BlankPage'));
//   const Dashboard = React.lazy(() => import("./containers/Dashboard/Dashboard"));

//   const RestrictedRoute= ({ component: Component, ...rest }) => {

//     const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);

//       return(
//       <Route
//         {...rest}
//         render={props =>
//           isLoggedIn ? (
//             <Component {...props} />
//           ) : (
//             <Redirect
//               to={{
//                 pathname:"/islogged",
//                 pg: window.location.pathname
//             }}
//             />
//           )
//         }
//       />)}

// /**
//  * 
//  * Rotas públicas, verifica depois do .com.br
//  */

  
// const PublicRoutes = ({ history }) => {
//   return (
//     <React.Fragment> 
//       <Suspense fallback={<Loader />}>
//         <ConnectedRouter history={history}>
//           <Router history={history}>
           
//             <Route
//               exact
//               path={'/'}
//               component={withLayout(Page)}
//             />

//           <RestrictedRoute
//             path="/dashboard"
//             component={Dashboard}
//           />  
//             <RestrictedRoute
//               path="/logged"
//               component={Dashboard}
//             /> 
//           </Router>
//         </ConnectedRouter>
//         </Suspense>
//     </React.Fragment>
//   );
// };

// function withLayout(WrappedComponent, hasDarkTopBar) {
//   // ...and returns another component...
//   return class extends React.Component {
//     render() {
//       return (
//         <Layout hasDarkTopBar={hasDarkTopBar}>
//           <WrappedComponent></WrappedComponent>
//         </Layout>
//       );
//     }
//   };
// }


// export default PublicRoutes;